import styled from "styled-components";

export const CollapseStyle = styled.div`
// .collapse-item .collapse-header{
//     background-color:#f8f8f8;
// }
// .collapse-item .collapse-body{
//     background-color:#fff !important;
// }
.hide-collapse{
    height:0;
    transform:scaleY(0);
    transition:all .2s;
    transform-origin:top;
  }
  .show-collapse{
    transform:scaleY(1);
    transition:all .7s;
    transform-origin:bottom; 
    min-height:100px;
  
  }
  

`;